import {Select} from 'evergreen-ui';
import React from 'react';
import {getDisabledSelect, getNotSelectedValueLabel} from '../../Filters/utils';
import {CategoryType, CategoryTypeSelectProps} from "../../Filters/CategoryTypeSelect";
import {useGetStationTypesQuery} from "../../../Services/api/stationTypesApi";


// TODO: сделать все также как и в RegionSelect
export function CategoryTypeSelectMonitoring({
                                       selected,
                                       onSelect,
                                       onChange,
                                   }: CategoryTypeSelectProps) {
    /*
    Есть также все типы по ресту: /stationtypes
    Есть категории, который также могут иметь список типов ресть: /stationcats
    */
    const { data, isLoading } = useGetStationTypesQuery(undefined);
    const types = (data || []) as CategoryType[]

    const { disabledSelect, notSelectedValueLabel } = React.useMemo(() => {
        return {
            notSelectedValueLabel: getNotSelectedValueLabel({
                isLoading,
                dataLength: types.length,
                label: 'ВСЕ ТИПЫ',
                noDataLabel: 'Нет типов'
            }),
            disabledSelect: getDisabledSelect({
                isLoading, dataLength:
                types.length
            }),
        };
    }, [isLoading]);

    const onChangeType = React.useCallback((event:React.ChangeEvent<HTMLSelectElement>) => {
        const selected = event.target.value;
        if (selected === '-1') {
          onSelect && onSelect(undefined);
        } else {
            onSelect && onSelect(Number(selected));
        }
        onChange && onChange(event);
    }, []);

    return (
        <Select value={selected ?? -1} onChange={onChangeType} disabled={disabledSelect}>
            <option value={-1}>{notSelectedValueLabel}</option>
            {
                types?.map(({ id, name}) => {
                    return (
                        <React.Fragment key={id}>
                            <option value={id}>{name}</option>
                        </React.Fragment>
                    );
                })
            }
        </Select>
    );
}
export const MemoCategoryTypeSelectMonitoring = React.memo(CategoryTypeSelectMonitoring);
MemoCategoryTypeSelectMonitoring.displayName = 'MemoCategoryTypeSelectMonitoring';
export default CategoryTypeSelectMonitoring;
